export const GOOD = 0;
export const FAIR = 1;
export const BAD = 2;
export const RANGE_COLOR = "rgba(201, 210, 219, 0.3)";
export const SELECTED_RANGE_COLOR = "rgba(0, 136, 206, 0.3)";
export const ANNOTATION_COLOR = "#7690A4";
